var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose, Type } from 'class-transformer';
import { IsArray, IsOptional, IsString, IsUUID, MaxLength, MinLength } from 'class-validator';
import { CreateExerciseProgramItemDto } from '../../exercise-programs/index.js';
export class CreateExerciseTemplateDto {
    name;
    exerciseProgramItems;
    exerciseTemplateFolderIds = [];
    officeId;
}
__decorate([
    IsString(),
    MinLength(1),
    MaxLength(255),
    Expose(),
    __metadata("design:type", String)
], CreateExerciseTemplateDto.prototype, "name", void 0);
__decorate([
    IsArray(),
    Type(() => CreateExerciseProgramItemDto)
    /* @ValidateNested({ each: true }) */ // TODO: Does not work in e2e-tests for some reason
    ,
    Expose(),
    __metadata("design:type", Array)
], CreateExerciseTemplateDto.prototype, "exerciseProgramItems", void 0);
__decorate([
    IsArray(),
    IsUUID(4, { each: true }),
    Expose(),
    IsOptional(),
    __metadata("design:type", Array)
], CreateExerciseTemplateDto.prototype, "exerciseTemplateFolderIds", void 0);
__decorate([
    IsUUID(),
    IsOptional(),
    Expose(),
    __metadata("design:type", String)
], CreateExerciseTemplateDto.prototype, "officeId", void 0);
//# sourceMappingURL=create-exercise-template.dto.js.map